<template>
  <center class="logo-container">
    <v-img
      :src="logoImage"
      max-height="90px"
      max-width="240px"
      contain
    />
  </center>
</template>

<script>
export default {
  props: {
    logoImage: {
      type: String,
      default: null
    }
  },
};
</script>

<style scoped>
.logo-container {
  min-height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
